import store from '@/store/index';
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage/LoginPage.vue';
import FamiliesRoute from './routes/families';
import addFamilyExternalRoute from './routes/addFamilyExternal';
import addFamilyRoute from './routes/addFamily';
import pendingFamiliesRoute from './routes/pendingFamilies';
import familyCard from './routes/familyCard';
import sheetRoute from './routes/sheet';
import sheetTwoRoute from './routes/sheetTwo';
import familiesToDecide from './routes/familiesToDecide';
import familiesToApproval from './routes/familiesToApproval';
import description from './routes/description';
import warehouse from './routes/warehouse';
import giftGivingReport from './routes/giftGivingReport';
import manageSwr from '@/router/routes/manageSwr';
import specialistPackage from '@/router/routes/specialistPackage';
import furtherStory from '@/router/routes/furtherStory';

export default [
    { path: '/', name: 'home', component: HomePage, meta: { requiresAuth: true } },
    {
        path: '/login',
        name: 'login',
        props: true,
        component: LoginPage,
        beforeEnter: (to, from, next) => {
            if (store.getters.getIsLoggedIn) {
                next(false);
                return;
            }
            next();
        }
    },
    FamiliesRoute,
    addFamilyExternalRoute,
    addFamilyRoute,
    pendingFamiliesRoute,
    sheetRoute,
    sheetTwoRoute,
    familiesToDecide,
    familiesToApproval,
    ...familyCard,
    description,
    ...warehouse,
    giftGivingReport,
    manageSwr,
    ...specialistPackage,
    ...furtherStory
];
